import { IconWrapper } from '../runtime';
export default IconWrapper('poster_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#6964FA"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#5651E6"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#817CFF"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.50118 9.00046C8.77732 9.00046 9.00118 8.7766 9.00118 8.50046C9.00118 8.22432 8.77732 8.00046 8.50118 8.00046C8.22503 8.00046 8.00118 8.22432 8.00118 8.50046C8.00118 8.7766 8.22503 9.00046 8.50118 9.00046Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.64515 2.0697L3.50852 5.12831L4.85492 7.50657L3.19531 8.48282L3.80374 9.51714L5.1611 8.71869C5.199 9.17404 5.33086 9.60409 5.55844 9.98633C6.05747 10.8245 6.9606 11.3373 8.08774 11.3974C9.3897 11.4668 10.4836 11.1829 11.2715 10.6575C12.0596 10.1319 12.5556 9.34717 12.5556 8.47161C12.5556 7.95957 12.4322 7.48221 12.1588 7.09074C11.9643 6.81209 11.7081 6.59783 11.4076 6.4501C11.332 6.04457 11.1495 5.66315 10.8734 5.35849L12.3037 4.51714L11.6953 3.48282L10.072 4.43771L8.64515 2.0697ZM9.03761 5.04617L8.23341 3.7115L5.13115 5.55874L5.88939 6.89807L9.03761 5.04617ZM6.58952 9.37243C6.38128 9.02267 6.28998 8.55047 6.39025 7.99566L9.78135 6.00089C10.0619 6.16656 10.2471 6.48953 10.2471 6.87771V7.33616L10.6895 7.45663C10.9214 7.51979 11.0744 7.63372 11.175 7.77774C11.2788 7.92651 11.3556 8.14969 11.3556 8.47161C11.3556 8.86366 11.135 9.30621 10.6058 9.65909C10.0764 10.0121 9.25236 10.2577 8.15159 10.1991C7.36444 10.1571 6.85497 9.81826 6.58952 9.37243Z",
      "fill": "white"
    }
  })]);
});